export const REDUCER_NAME = "matchChannel";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_MATCHCHANNEL = `${REDUCER_NAME}/SET_MATCHCHANNEL`;

export const getKey = (data) => `${data.id}`;
